export const DATANYZE_DOMAIN = '.datanyze.com';
export const COOKIE_NAME = 'CookieConsent';
export const TERMS_OF_SERVICE = 'terms-conditions';
export const COUNTRY_ENDPOINT = '/country';
export enum SameSite {
  LAX = 'Lax',
}

export interface CountryFetchResponse {
  isGDPR: boolean;
  country: string;
}
